import * as React from "react";
import {
  ReservesSearchEvent,
  ReservesSearchForm,
} from "../../ReservesSearchForm";
import { LoaderFunctionArgs, redirect } from "react-router";
import { LocationConfigurationHolder } from "../../LocationConfiguration";

export async function reservesLoader({ request }: LoaderFunctionArgs) {
  console.log("reservesLoader executing");

  const { pacSettings } =
    await LocationConfigurationHolder.fetchLocationConfiguration();

  if (!pacSettings.reservesEnabled) {
    return redirect("/advanced-search/boolean");
  }

  return {};
}

export const ReservesSearchPage: React.FC = () => {
  const handleReservesSearch = ({
    department,
    course,
    instructor,
    branchFilters,
  }: ReservesSearchEvent) => {
    const params = new URLSearchParams();
    params.set("section", "search");
    params.set("page", "0");
    params.set("sortKey", "Course");
    params.set("db", "reserves");
    params.set("branchFilters", JSON.stringify(branchFilters));

    if (department) {
      params.set("department", department);
    }

    if (course) {
      params.set("course", course);
    }

    if (instructor) {
      params.set("instructor", instructor);
    }

    window.location.hash = params.toString();
  };

  return (
    <ReservesSearchForm
      onClickSearch={handleReservesSearch}
    ></ReservesSearchForm>
  );
};
